/**
 * TanStack Router: /janes
 *
 * This route file was auto-generated by the route generation script.
 * Component: JanesPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import JanesPage from '@/app/janes/page'

/**
 * Route: /janes
 * Layout: _auth (authenticated)
 * Component: JanesPage
 */
export const Route = createFileRoute('/_auth/janes')({
  component: JanesPage,
})
